module.exports = __webpack_public_path__ + "static/media/Logomark-01.a7d43166.svg";